// service name
import { toLower } from 'lodash';

// patient has a care plan
export const KAYTTAJA = 'käyttäjä';

// patient has requested a care plan
export const PYYDETTY = 'pyydetty';

// patient has stopped using a care plan
export const SULJETTU = 'suljettu';

// patient has no markings of any care plan
export const EITIETOA = 'noCarePlans';

export const TAYS_POLKU = 'Tays polku';

export const COXA_POLKU = 'CoxaPolku';

export const compareStatus = (status1, status2) => {
  return toLower(status1) === toLower(status2);
};

export default {
  KAYTTAJA,
  PYYDETTY,
  EITIETOA,
  SULJETTU,
};